export const CARESERVICE_ADD_STEP = 'CARESERVICE_ADD_STEP';
export const CARESERVICE_UPDATE_FACT = 'CARESERVICE_UPDATE_FACT';
export const CARESERVICE_REMOVE_STEP = 'CARESERVICE_REMOVE_STEP';
export const CARESERVICE_UPDATE_CARELEVEL = 'CARESERVICE_UPDATE_CARELEVEL';
export const CARESERVICE_SAVE = 'CARESERVICE_SAVE';
export const CARESERVICE_REQUEST = 'CARESERVICE_REQUEST';
export const CARESERVICE_CLEAR_WIZARD = 'CARESERVICE_CLEAR_WIZARD';
